<div class="flex flex-col full-grow-no-shrink-no-basis">
    <div class="modal-header flex flex-row justify-between items-center">
        <h1>Update Solution</h1>

        <mat-dialog-actions>
            <button class="material-icons" mat-dialog-close
                    particleAnalytics
                    analyticsCategory="ed-cell-editor-container"
                    analyticsAction="close-btn"><i class="fa-regular fa-xmark"></i>
            </button>
        </mat-dialog-actions>

    </div>

    <mat-dialog-content class="full-grow-no-shrink-no-basis">
        <form class="flex flex-col full-grow-no-shrink-no-basis" [formGroup]="updateSolutionForm">
            <div class="flex flex-col flex-1-0-auto">

                <div class="flex flex-row justify-start items-start auto-flex">
                    <mat-form-field appearance="outline" class="flex-1-1-100">
                        <mat-label>Product</mat-label>
                        <input matInput formControlName="product"
                               particleAnalytics
                               analyticsCategory="account-settings"
                               analyticsAction="password-input">
                    </mat-form-field>
                </div>

                <div class="flex flex-row justify-start items-start auto-flex">
                    <mat-form-field appearance="outline" class="flex-1-1-100">
                        <mat-label>Solution</mat-label>
                        <input matInput formControlName="solution"
                               particleAnalytics
                               analyticsCategory="account-settings"
                               analyticsAction="password-input">
                    </mat-form-field>
                </div>

                <div class="flex flex-row justify-start items-start auto-flex">
                    <mat-checkbox formControlName="isActive">Is Active</mat-checkbox>
                </div>

                <div class="m-t-10 flex flex-row justify-start items-center auto-flex">
                    <mat-form-field appearance="outline" class="orbitax-date-picker flex-1-1-35"
                                    particleAnalytics
                                    analyticsCategory="update-solution"
                                    analyticsAction="expiry-date">
                        <mat-label>Expiry Date:</mat-label>
                        <input matInput formControlName="expiryDate" [(ngModel)]="updateSolutionForm.value.expiryDate"
                               [matDatepicker]="picker">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                    <button mat-button class="m-l-20  orbitax-footer-button" style="position: relative;top: -8px"
                            (click)="addOneYear()">+1 Year
                    </button>
                </div>

            </div>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions class="modal-footer flex flex-row justify-between items-center">
        <button mat-button class="mat-flat-button orbitax-footer-button mat-button" [mat-dialog-close]="result">Cancel
        </button>
        <button mat-button (click)="onSave()" [mat-dialog-close]="result" mat-flat-button
                class="orbitax-footer-action-button mat-button mat-flat-button mat-accent" type="button" color="accent"
                [disabled]="!updateSolutionForm.valid" cdkFocusInitial>Save
        </button>
    </mat-dialog-actions>
</div>
